(() => {
'use strict';
if(window.aaP3GranddaughterCart)return;
const script=document.querySelector('script[data-p3-granddaughter-cart]');
const kits=JSON.parse(script?.dataset.kits||'[]');
const product=15438059831660,kitProduct=15438061732204;
const route=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
let snapshot=null, pending=null, changing=false, refreshing=null;
const api=async(path,body)=>{
 const res=await fetch(route+path,body?{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)}:undefined);
 const json=await res.json();if(!res.ok)throw Error(json.description||'Your cart could not be updated. Please try again.');return json;
};
const primaries=c=>c.items.filter(l=>Number(l.product_id)===product&&l.properties?._aap3_ref);
const sets=c=>c.items.filter(l=>Number(l.product_id)===kitProduct);
const note=text=>{let el=document.querySelector('[data-p3-cart-status]');if(!el){el=document.createElement('p');el.dataset.p3CartStatus='';el.setAttribute('role','alert');el.style.cssText='font-size:16px;padding:16px;border:1px solid #bbb;background:#fff';(document.querySelector('.cart-recap')||document.querySelector('cart-drawer [slot=footer]')||document.querySelector('main')).prepend(el);}el.textContent=text;};
function refresh(open=false){
 if(!open&&location.pathname.replace(/\/$/,'').endsWith('/cart')){location.reload();return Promise.resolve();}
 if(refreshing)return refreshing.then(()=>{if(open)return document.querySelector('cart-drawer#cart-drawer')?.show();});
 refreshing=(async()=>{
  const drawer=document.querySelector('cart-drawer#cart-drawer');
  if(!drawer)throw Error('Your gifts are saved. Please refresh this page to open your cart.');
  await customElements.whenDefined('cart-drawer');
  // Prestige emits this only after its fresh drawer content has been installed.
  await new Promise((resolve,reject)=>{
   const done=()=>{clearTimeout(timer);drawer.removeEventListener('cart-drawer:refreshed',done);resolve();};
   const timer=setTimeout(()=>{drawer.removeEventListener('cart-drawer:refreshed',done);reject(Error('Your gifts are saved. Please try opening your cart again.'));},15000);
   drawer.addEventListener('cart-drawer:refreshed',done);
   document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
  });
  paintEditLinks(snapshot);
  if(open)await drawer.show();
 })().finally(()=>refreshing=null);
 return refreshing;
}
async function normalize(){
 let cart=await api('cart.js');
 const count=primaries(cart).filter(l=>l.properties._aap3_led==='1').reduce((n,l)=>n+l.quantity,0);
 if(count>100)throw Error('For more than 100 gifts, contact our team so we can arrange the boxes with you.');
 const kit=kits.find(k=>k.n===count),existing=sets(cart);
 const correct=count?existing.length===1&&Number(existing[0].variant_id)===kit?.id&&existing[0].quantity===1:existing.length===0;
 if(!correct){
  if(existing.length){await api('cart/update.js',{updates:Object.fromEntries(existing.map(l=>[l.key,0]))});}
  if(count){
   if(!kit)throw Error('The LED upgrade is temporarily unavailable. Your rings are saved in your cart.');
   await api('cart/add.js',{items:[{id:kit.id,quantity:1,properties:{_aap3_role:'led-set',_aap3_offer:'granddaughter-002','Box style':'Ring','Boxes included':String(count),'For':'My Precious Granddaughter Hug Ring','Upgrade':'One flat price for all selected gifts'}}]});
  }
  cart=await api('cart.js');
 }
 snapshot=cart;paintEditLinks(cart);return cart;
}
const reconcile=()=>pending||(pending=normalize().finally(()=>pending=null));
function paintEditLinks(cart){
 if(!cart)return;
 document.querySelectorAll('input[data-line-key]').forEach(input=>{
  const line=primaries(cart).find(l=>l.key===input.dataset.lineKey);if(!line)return;
  const wrap=input.closest('tr')||input.closest('line-item');if(!wrap||wrap.querySelector('[data-p3-edit]'))return;
  const link=document.createElement('a');link.dataset.p3Edit='';link.textContent='Edit gift';link.href=route+'products/my-precious-granddaughter-hug-ring?variant='+line.variant_id+'&p3_edit='+encodeURIComponent(line.properties._aap3_ref);
  link.style.cssText='display:inline-block;font-size:14px;text-decoration:underline;padding:8px 0';
  (wrap.querySelector('.line-item-info')||wrap).append(link);
 });
}
async function change(key,quantity){
 if(changing)return;changing=true;
 try{
  const cart=await api('cart.js');const line=cart.items.find(l=>l.key===key||String(l.variant_id)===String(key));if(!line)return;
  if(Number(line.product_id)===kitProduct){
   if(quantity!==0){await refresh();note('The LED upgrade covers every selected gift. Change the ring quantities to change the number of boxes.');return;}
   for(const original of primaries(cart).filter(p=>p.properties._aap3_led==='1')){
    const current=await api('cart.js');
    const p=primaries(current).find(l=>l.properties._aap3_ref===original.properties._aap3_ref);if(!p)continue;
    const props={...p.properties,_aap3_led:'0','Gift box':'Standard box included'};
    await api('cart/change.js',{id:p.key,quantity:p.quantity,properties:props});
   }
  }else{
   const nextCount=primaries(cart).filter(l=>l.properties._aap3_led==='1').reduce((n,l)=>n+(l.key===line.key?quantity:l.quantity),0);
   if(nextCount>100){note('Choose up to 100 gifts online, or contact our team for a larger order.');return;}
   await api('cart/change.js',{id:line.key,quantity});
  }
  await reconcile();await refresh();
 }catch(e){note(e.message);}finally{changing=false;}
}
document.addEventListener('change',e=>{
 const input=e.target.closest?.('input[data-line-key]');if(!input||!snapshot)return;
 const line=snapshot.items.find(l=>l.key===input.dataset.lineKey);if(!line||![product,kitProduct].includes(Number(line.product_id)))return;
 e.preventDefault();e.stopImmediatePropagation();const q=Number(input.value);if(Number.isSafeInteger(q)&&q>=0)change(line.key,q);
},true);
document.addEventListener('click',e=>{
 const a=e.target.closest?.('a[href*="/cart/change"]');if(!a||!snapshot)return;
 const url=new URL(a.href),key=url.searchParams.get('id'),q=Number(url.searchParams.get('quantity'));
 const line=snapshot.items.find(l=>l.key===key||String(l.variant_id)===key);if(!line||![product,kitProduct].includes(Number(line.product_id)))return;
 e.preventDefault();e.stopImmediatePropagation();if(Number.isSafeInteger(q)&&q>=0)change(line.key,q);
},true);
document.addEventListener('submit',e=>{
 if(!e.submitter?.matches('[name="checkout"]')||!snapshot||!primaries(snapshot).length)return;
 e.preventDefault();e.stopImmediatePropagation();if(changing)return;
 reconcile().then(()=>location.assign(route+'checkout')).catch(e=>note(e.message));
},true);
document.addEventListener('click',e=>{
 const link=e.target.closest?.('a[href*="/checkout"]');if(!link||!snapshot||!primaries(snapshot).length)return;
 e.preventDefault();e.stopImmediatePropagation();if(changing)return;
 reconcile().then(()=>location.assign(link.href)).catch(e=>note(e.message));
},true);
document.addEventListener('cart:change',()=>{api('cart.js').then(c=>{snapshot=c;paintEditLinks(c);}).catch(()=>{});});
document.addEventListener('cart-drawer:refreshed',()=>paintEditLinks(snapshot));
window.aaP3GranddaughterCart={api,reconcile,change,refresh,kitFor:n=>kits.find(k=>k.n===n),get busy(){return changing||!!pending||!!refreshing;}};
window.addEventListener('pageshow',()=>{
 if(location.pathname.replace(/\/$/,'').endsWith('/cart'))return;
 reconcile().then(c=>{if(primaries(c).length||sets(c).length)return refresh();}).catch(e=>note(e.message));
});
window.addEventListener('pageshow',()=>{reconcile().then(cart=>{if(primaries(cart).length)return refresh();}).catch(e=>note(e.message));});
window.dispatchEvent(new Event('aa:p3-granddaughter-cart-ready'));
reconcile().catch(e=>note(e.message));
})();
